export default __webpack_public_path__ + "static/brush2-9494b853d416fc839c41f0cccc1a8902.png";